export default __webpack_public_path__ + "static/media/impacto-5.55f34a40.png";